import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaAuth } from './lib/okta-auth';
import { SecureRoute } from './components/SecureRoute';
import { AppShell } from './components/AppShell';
import { Login } from './pages/Login';
import { LoginCallback } from './pages/LoginCallback';
import { Overview } from './pages/Overview';
import { MyAgents } from './pages/MyAgents';
import { MyTools } from './pages/MyTools';
import { RequestAccess } from './pages/RequestAccess';
import { AgentOwners } from './pages/AgentOwners';

function App() {
  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<LoginCallback />} />

          <Route element={<SecureRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Overview />} />
              <Route path="/agents" element={<MyAgents />} />
              <Route path="/tools" element={<MyTools />} />
              <Route path="/request-access" element={<RequestAccess />} />
              <Route path="/owners" element={<AgentOwners />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Security>
    </BrowserRouter>
  );
}

export default App;
